import React from 'react';
import './SequencesPage.css'; // optional for styling

export default function SequencesPage() {
  return (
    <div className="sequences-page">
      <h2>🔁 Sequences</h2>
      <p>Set up automated follow-up sequences (SMS, email, calls).</p>
    </div>
  );
}